import React from "react";
import LegalPageLayout, { Section, SectionTitle, Paragraph, List } from "components/legal/LegalPageLayout.js";

export default () => {
  return (
    <LegalPageLayout
      productName="Mind Aspirants"
      productUrl="/products/mind-aspirant"
      title="Refund Policy"
      lastUpdated="July 10, 2026"
    >
      <Section>
        <Paragraph>
          This Refund Policy applies to entry fees and prize payouts on the Mind Aspirants app operated by <strong>Spurnest Techlabs</strong>.
        </Paragraph>
      </Section>

      <Section>
        <SectionTitle>Entry Fees</SectionTitle>
        <List>
          <li>Quiz entry fees (e.g. ₹10) are <strong>non-refundable</strong> once the quiz has started.</li>
          <li>If a quiz is cancelled by us before it begins, entry fees will be refunded to your wallet or original payment method within 7 business days.</li>
          <li>Technical failures on our side that prevent quiz participation may qualify for a refund — contact support within 24 hours.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Prize Payouts</SectionTitle>
        <List>
          <li>Prize winnings are credited based on the published prize breakout table after quiz completion.</li>
          <li>Winners may be required to complete identity verification before withdrawal.</li>
          <li>Payouts are processed within 7–14 business days of verification.</li>
          <li>Minimum withdrawal amounts and processing fees (if any) are displayed in the app.</li>
        </List>
      </Section>

      <Section>
        <SectionTitle>Disputes</SectionTitle>
        <Paragraph>
          For refund or payout disputes, email{" "}
          <a href="mailto:info@spurnest.com" tw="text-primary-500 font-semibold">info@spurnest.com</a>{" "}
          with your registered mobile number, quiz ID, and transaction details. We respond within 5 business days.
        </Paragraph>
      </Section>
    </LegalPageLayout>
  );
};
